import { useState, Fragment, useEffect } from "react";
import { CircularProgress, Backdrop, TextField, Grid, Box, Paper, Snackbar, BottomNavigation, BottomNavigationAction, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, useMediaQuery, useTheme } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AddCardIcon from '@mui/icons-material/AddCard';

import "../css/Retiros.css"

import axios from "../api/axios"
import useAuth from '../hooks/useAuth';

export default function RetiroDisponible() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [mensaje, setMensaje] = useState("")
    const [disponible, setDisponible] = useState(0.00)
    const [monto, setMonto] = useState(0.00)
    const [comentario, setComentario] = useState("")
    const [openConfirmacion, setOpenConfirmacion] = useState(false)
    const [procesando, setProcesando] = useState(false)

    const { auth } = useAuth();
    const [montoError, setMontoError] = useState("");

    const actDisponible = async () => {
        try {
            const respuesta = await axios.post("retiros/disponible", {
                inversionista: auth.inversionista,
                tipo: 1
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;
            if (data.respuesta === "S") {
                setDisponible(parseFloat(data.disponible) || 0)
                setMontoError("")
            }
        } catch (error) {
            console.log(error)
        }
    }

    // Cargar al montar el componente
    useEffect(() => {
        actDisponible();
    }, [])

    // Recargar cuando cambie el inversionista
    useEffect(() => {
        actDisponible();
    }, [auth.inversionista])

    const handleCloseMensaje = () => {
        setMensaje("")
    }
    const actionMsg = (
        <Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseMensaje}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </Fragment>
    );

    const confirmaGrabar = () => {
        return (
            <Dialog
                open={openConfirmacion}
                fullScreen={isMobile}
                PaperProps={{
                    sx: isMobile ? {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center'
                    } : {}
                }}
            >
                <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    color: 'white',
                    textAlign: 'center',
                    fontWeight: 600
                }}>
                    Confirmación
                </DialogTitle>
                <DialogContent sx={{
                    py: isMobile ? 4 : 2,
                    px: isMobile ? 3 : 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Typography sx={{
                        textAlign: 'center',
                        fontSize: isMobile ? '1.1rem' : '1rem',
                        color: '#1e3a5f'
                    }}>
                        ¿Desea solicitar este retiro de disponible?
                    </Typography>
                </DialogContent>
                <DialogActions sx={{
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? 1.5 : 1,
                    p: isMobile ? 3 : 2
                }}>
                    <Button
                        onClick={handleCerrarConfirmar}
                        variant="outlined"
                        fullWidth={isMobile}
                        sx={{
                            order: isMobile ? 2 : 1,
                            color: '#1e3a5f',
                            borderColor: '#1e3a5f',
                            py: isMobile ? 1.5 : 1
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => grabar()}
                        variant="contained"
                        fullWidth={isMobile}
                        sx={{
                            order: isMobile ? 1 : 2,
                            background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                            py: isMobile ? 1.5 : 1,
                            '&:hover': {
                                background: 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)'
                            }
                        }}
                    >
                        Solicitar!
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const grabar = async () => {
        setOpenConfirmacion(false)
        setProcesando(true)
        try {
            const respuesta = await axios.post("retiros/grabar", {
                inversionista: auth.inversionista,
                tipo: 1,
                monto: String(monto),
                tiporetiroganancia: 0,
                comentario: comentario
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            let data = respuesta.data;
            if (typeof data === 'string') {
                data = JSON.parse(data);
            }
            if (data.respuesta === "S") {
                limpiaPantalla();
                setMensaje("Retiro de disponible solicitado exitosamente")
                actDisponible()
            } else {
                setMensaje(data.mensaje)
            }

        } catch (error) {
            console.log(error)
            setMensaje("Ha ocurrido un error de conexion, por favor intente mas tarde")
        }
        setProcesando(false)
    }

    const puedeGrabar = () => {
        let resultado = true;
        const montoNum = parseFloat(monto);
        const disponibleNum = parseFloat(disponible);

        if (isNaN(montoNum) || montoNum <= 0) {
            setMensaje("Debe digitar un monto valido mayor a cero")
            resultado = false;
        } else if (montoNum > disponibleNum) {
            const disponibleFormateado = disponibleNum.toLocaleString('en-US', { minimumFractionDigits: 2 });
            setMensaje(`El monto solicitado excede su disponible (${disponibleFormateado})`)
            resultado = false;
        }
        return resultado;
    }

    const handleClickGrabar = () => {
        if (puedeGrabar()) {
            setOpenConfirmacion(true)
        }
    }

    const limpiaPantalla = () => {
        setComentario("")
        setMonto("0.00")
        setMontoError("")
    }

    const handleCerrarConfirmar = () => {
        setOpenConfirmacion(false)
    }

    const objWait = () => {
        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={procesando}
                onClick={() => { setProcesando(false) }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    return (
        <Box sx={{
            width: "100%",
            height: "100%",
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: isMobile ? "flex-start" : "center",
            p: isMobile ? 1 : 0
        }}>
            <Snackbar
                open={mensaje.length === 0 ? false : true}
                autoHideDuration={6000}
                onClose={handleCloseMensaje}
                action={actionMsg}
                message={mensaje}
                sx={isMobile ? { bottom: 70 } : {}}
            />
            {objWait()}
            {confirmaGrabar()}
            <Paper className="paper" sx={isMobile ? {
                width: '100%',
                maxWidth: '100%',
                margin: 0,
                borderRadius: '12px !important'
            } : {}}>
                <Box sx={{
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    borderRadius: '8px 8px 0 0',
                    borderBottom: '3px solid #d4af37'
                }} padding={isMobile ? 1.5 : 2}>
                    <Typography
                        variant={isMobile ? 'h6' : 'h5'}
                        sx={{
                            color: "white",
                            textAlign: "center",
                            fontWeight: 700,
                            letterSpacing: 1
                        }}
                    >
                        Retiro de Disponible
                    </Typography>
                </Box>
                <BottomNavigation
                    sx={{
                        marginBottom: isMobile ? "16px" : "30px",
                        '& .MuiBottomNavigationAction-root': {
                            minWidth: isMobile ? 'auto' : 80,
                            padding: isMobile ? '6px 12px' : '6px 12px 8px'
                        },
                        '& .MuiBottomNavigationAction-label': {
                            fontSize: isMobile ? '0.75rem' : '0.75rem'
                        }
                    }}
                    showLabels
                    onChange={(_, newValue) => {
                        if (newValue === 0) { limpiaPantalla(); actDisponible(); }
                    }}
                >
                    <BottomNavigationAction label="Nuevo" icon={<SaveAltIcon />} />
                </BottomNavigation>

                {/* Mostrar disponible como tarjeta en móvil */}
                {isMobile ? (
                    <Box sx={{
                        mb: 2,
                        p: 2,
                        background: 'rgba(30, 58, 95, 0.05)',
                        borderRadius: '12px',
                        border: '1px solid rgba(30, 58, 95, 0.1)',
                        textAlign: 'center'
                    }}>
                        <Typography variant="caption" sx={{ color: '#4a5568', display: 'block', mb: 0.5 }}>
                            Mi disponible
                        </Typography>
                        <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#d4af37' }}>
                            {parseFloat(disponible).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                        </Typography>
                    </Box>
                ) : (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Box sx={{ display: "flex", justifyContent: "center" }}>
                                <TextField
                                    disabled
                                    size='small'
                                    id="mi-disponible"
                                    label="Mi disponible"
                                    value={parseFloat(disponible).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                    InputLabelProps={{
                                        readOnly: true
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                )}

                <Grid container spacing={isMobile ? 1.5 : 2}>
                    <Grid item xs={12}>
                        <Box sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "center"
                        }}>
                            <TextField
                                size={isMobile ? 'medium' : 'large'}
                                id="monto-retirar"
                                type="number"
                                label="Monto a Retirar:"
                                fullWidth={isMobile}
                                onChange={(event) => {
                                    const valor = event.target.value;
                                    setMonto(valor);
                                    const valorNum = parseFloat(valor);
                                    const disponibleNum = parseFloat(disponible);
                                    if (valorNum > disponibleNum) {
                                        setMontoError(`Excede el disponible (${disponibleNum.toLocaleString('en-US', { minimumFractionDigits: 2 })})`);
                                    } else {
                                        setMontoError("");
                                    }
                                }}
                                value={monto}
                                error={montoError.length > 0}
                                helperText={montoError}
                                sx={isMobile ? {
                                    '& .MuiInputBase-input': {
                                        fontSize: '1.25rem',
                                        fontWeight: 'bold',
                                        textAlign: 'center'
                                    }
                                } : {}}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="nota"
                            fullWidth
                            value={comentario}
                            onChange={(event) => { setComentario(event.target.value) }}
                            label="Comentario"
                            multiline
                            maxRows={4}
                            size={isMobile ? 'medium' : 'medium'}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            fullWidth
                            size="large"
                            onClick={handleClickGrabar}
                            sx={{
                                mt: 1,
                                py: 1.5,
                                fontSize: '1.1rem',
                                fontWeight: 'bold',
                                background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)'
                                }
                            }}
                        >
                            SOLICITAR RETIRO
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </Box>
    )
}
